import {db} from "@/firebase/init"

export default {
    data () {
        return {
            allUpComingAdmins: [],
        }
    },
    computed: {
    },
    methods: {
        async getUpcomingAdminsV2(){
            try{
                const {data} = await this.$http.post("utilities/get-upcoming-admins", {
                    grant_type: 'token'
                })
                this.allUpComingAdmins = data.upcomingAdmins
            }
            catch (e){
                console.log(e.toString(), 'Error in fetching upcoming admins')
            }
        }
    }
}
